import apiCall from "./axios_instance";
import config from "../config.json";
import { getStorageWithMultiTabCheck } from "../utils/global_functions";
import { API_SOURCE, LOCAL_STORAGE_KEYS } from "../utils/global_variables";

export async function fundsReport(startDate, endDate) {
    let payload = { "FromDate": startDate, "ToDate": endDate, "Status": 2, "bankId": "", "fund_type": "" };
    try {
        const objResp = await apiCall.post(`transactional/v1/fundsReport`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in fundsReport API ->", error.message);
        throw error;
    }
}

export async function marginInfo(objPayload) {
    try {
        const objResp = await apiCall.get(`/transactional/v1/marginInfo/${objPayload?.type}`);
        return objResp;
    } catch (error) {
        console.error("Error in marginInfo API ->", error.message);
        throw error;
    }
}


export async function UPIDetails() {
    try {
        const objResp = await apiCall.get(`transactional/v1/getUPIDetails`);
        return objResp;
    } catch (error) {
        console.error("Error in UPIDetails API ->", error.message);
        throw error;
    }
}

export async function netPosition(payload) {
    try {
        const objResp = await apiCall.get(`transactional/v1/portfolio/positions/${payload?.type}?intropStatus=${payload?.interopFlag}`);
        return objResp;
    } catch (error) {
        console.error("Error in Net Position API ->", error.message);
        throw error;
    }
}
// Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
export async function getUserAllOrders(objPayload) {
    try {
        const objResp = await apiCall.get(`transactional/v1/orders?offset=${objPayload.offSet}&limit=${objPayload.limit}&orderStatus=${objPayload.orderStatus}`);

        return objResp;
    } catch (error) {
        console.error("Error in getUserAllOrders API ->", error.message);
        throw error;
    }
}
// Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End




export async function placeUserSipOrders(objPayload, product_source = "BREEZEAPI") {
    try {
        const objResp = await apiCall.post(`/transactional/v1/orders/eqsip?product_source=${product_source}`, objPayload, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error("Error in placeUserSipOrders API ->", error.message);
        throw error;
    }
}
// Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
export async function getUserSipOrders(objPayload) {
    try {
        const objResp = await apiCall.get(`/transactional/v1/eqsipOrders?offset=${objPayload.offSet}&limit=${objPayload.limit}${objPayload.orderStatus?.toString()?.length > 0 ? '&orderStatus=' + objPayload.orderStatus : ''}`);
        return objResp;
    } catch (error) {
        console.error("Error in getUserSipOrders API ->", error.message);
        throw error;
    }
}
// Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End

export async function updateUserSipOrders(objPayload, product_source = "BREEZEAPI") {
    try {

        const objResp = await apiCall.post(`/transactional/v1/orders/eqsip?product_source=${product_source}`, objPayload, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error("Error in updateUserSipOrders API ->", error.message);
        throw error;
    }
}

// Vinit Raut : 17-05-2024 : BT-107418 - Breeze – SIP Order book -- Start
export async function cancelUserSipOrders(payload, product_source = "BREEZEAPI") {
    try {
        const objResp = await apiCall.put(`/transactional/v1/orders/eqsip/${payload.sip_id}/${payload.status}/${payload.company_name}/${payload.transaction_type}/${payload.invested_by}/1?product_source=${product_source}&newStatusId=${payload.newStatus}`);
        return objResp;
    } catch (error) {
        console.error("Error in cancelUserSipOrders API ->", error.message);
        throw error;
    }
}
// Vinit Raut : 17-05-2024 : BT-107418 - Breeze – SIP Order book -- End

export async function getUserSipSettingDetails() {
    try {
        const objResp = await apiCall.get(`/transactional/v1/eqsipSettingDetails`, { lock: true });
        return objResp;
    } catch (error) {
        console.error("Error in getUserSipSettingDetails API ->", error.message);
        throw error;
    }
}
export async function getUserSipOrderHistory(payload) {
    try {
        const objResp = await apiCall.get(`transactional/v1/eqsipOrderDetails/${payload}`);
        return objResp;
    } catch (error) {
        console.error("Error in getUserSipOrderHistory API ->", error.message);
        throw error;
    }
}
// Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - trades not showing – Start
export async function getUserTradeOrderdata(objPayload) {
    try {

        let orderId;

        if (config.appApiFlag) {
            orderId = objPayload?.order_ids;
        } else {
            orderId = encodeURIComponent(objPayload.order_ids);
        }

        const objResp = await apiCall.get(`transactional/v1/trades?offset=${objPayload.offSet}&limit=${objPayload.limit}&order_id=&order_ids=${orderId}`);
        return objResp;
    } catch (error) {
        console.error("Error in getUserTradeOrderData API ->", error.message);
        throw error;
    }
}
// Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue - trades not showing – End

export async function holdingsForWatchlist(payload) {
    try {
        const objresp = await apiCall.get(`transactional/${config.TenantId}/v1/getStockView/${payload?.user_id}/${payload?.groupId}/-1/%20/${API_SOURCE.BREEZE}/1/HOLDINGS`);
        return objresp;
    } catch (error) {
        console.error("Error in Holdings API ->", error);
    }
}

export async function holdings() {
    try {
        const objresp = await apiCall.get(`transactional/v1/portfolio/holdings`);
        return objresp;
    } catch (error) {
        console.error("Error in Holdings API ->", error);
    }
}


export async function holdingsAdditionalDetails(payload) {
    try {
        const objresp = await apiCall.get(`transactional/${config.TenantId}/v1/getStockView/${payload.user_id}/${payload.groupId}/-1/%20/${API_SOURCE.BREEZE}/1/ALL`); // need to replce the %20 with isin so that we will get all holdings additional data in single call
        return objresp;
    } catch (error) {
        console.error("Error in holdingsAdditionalInfo API ->", error.message);
    }
}

export async function getIpoList(ipoPayload) {
    try {
        const { offerName, offerType } = ipoPayload;
        const objResp = await apiCall.get(`transactional/v2/ipo/list?type=-1&offerName=${offerName}&offerType=${offerType}`);
        return objResp;
    } catch (error) {
        console.error("Error in get ipo details API ->", error.message);
    }
}
export async function orderMarginInfo(payload) {
    try {

        const objResp = await apiCall.post(`transactional/v1/getOrderMarginInfo`, payload, { isAllowedDeviceInfo: true });

        return objResp;
    } catch (error) {
        console.error("Error in OrderMarginInfo API ->", error.message);
    }
}


export async function getIpoDetails(IPOCode) {
    try {
        const objResp = await apiCall.get(`transactional/v2/ipo/details/${IPOCode}`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in get ipo details API ->", error.message);
    }
}

// single scrip place order - regular
export async function placeUserSingleScripOrders(objPayload) {

    try {
        const objResp = await apiCall.post(`transactional/v1/orders/regular`, objPayload, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error("Error in placeUserSingleScripOrders API ->", error.message);
        throw error;
    }
}
//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start

export async function placeUserSingleScripCoverOrders(objPayload) {

    try {
        const objResp = await apiCall.post(`transactional/v1/orders/cover`, objPayload, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error("Error in placeUserSingleScripCoverOrders API ->", error.message);
        throw error;
    }
}
//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start
export async function modifyUserSingleScripCoverOrders(objPayload, exchange, orderNo) {

    try {
        const objResp = await apiCall.put(`transactional/v1/orders/cover/${exchange}/${orderNo}`, objPayload, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error('error in modifyUserSingleScripCoverOrders API ->', error.message);
        throw error;
    }
}
//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End

//  Azeem K : 29-04-2025 : BREEZE-6539 - Breeze - Bracket Orders - Start
export async function modifyUserSingleScripBracketOrders(objPayload, exchange, orderNo) {
    //LLD comment: transactional api call function for modify bracket order
    try {
        const objResp = await apiCall.put(`transactional/v1/orders/bracket/${exchange}/${orderNo}`, objPayload, { isAllowedDeviceInfo: true });
        return objResp;

    } catch (error) {
        console.error('error in modifyUserSingleScripBracketOrders API ->', error.message);
        throw error;
    }
}
//  Azeem K : 29-04-2025 : BREEZE-6539 - Breeze - Bracket Orders - End



export async function placeUserSingleScripBracketOrders(objPayload) {

    try {
        const objResp = await apiCall.post(`transactional/v1/orders/bracket`, objPayload, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error("Error in placeUserSingleScripBracketOrders API ->", error.message);
        throw error;
    }
}

//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

export async function getSriptForSecondLeg(payload) {
    try {
        const objresp = await apiCall.post(`transactional/${config.TenantId}/v1/getScripForSecondLeg`, payload);
        return objresp;
    } catch (error) {
        console.error("Error in Holdings API ->", error);
    }
}

export async function placeMultilegOrder(objPayload) {
    try {
        const objResp = await apiCall.post(`transactional/v1/orders/multileg`, objPayload, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error('Error in placeMultilegOrder API', error);
        return error;
    }
}
export async function cancelMultilegOrder(objPayload) {
    try {
        const objResp = await apiCall.put(`transactional/v1/orders/multileg/cancel/${objPayload.gateway_order_no}`, objPayload.data, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error('Error in placeMultilegOrder API', error);
        return error;
    }
}
export async function getPlaceModifyBid(payload) {
    try {
        // Vaibhav Singh: 04-07-25: Start:  Whenever in future we introduce 24/7 ipo then we need to changes api from v1 to v2
        const objResp = await apiCall.post(`transactional/v2/ipo/orders`, payload); //BREEZE-239 : IPO PREBID : ManasaB : 20-03-2025 : Changed from v1 to v2 as per suggestion from Chetan in order to do prebid in Upcoming IPO
        // Vaibhav Singh: 04-07-25: End
        return objResp;
    } catch (error) {
        console.error("Error in get place bid API ->", error.message);
        throw error;
    }
}


export async function getOrderBook(orderBookPayload) {
    try {
        const { startdate, endDate, offername, ipocode, applicationNo } = orderBookPayload;
        const objResp = await apiCall.get(`transactional/v2/ipo/orders?startdate=${startdate}&endDate=${endDate}&offerType=1&offername=${offername}&status=-1&ipoCode=${ipocode}&applicationNo=${applicationNo}`);

        return objResp;
    } catch (error) {
        console.error("Error in order book API ->", error.message);
        throw error;
    }
}

export async function cancelPlaceBid(payload) {
    try {
        const objResp = await apiCall.delete(`transactional/v2/ipo/orders/${payload}`);
        return objResp;
    } catch (error) {
        console.error("Error in get place bid API ->", error.message);
        throw error;
    }
}

//mutualfund

export async function createUserMutualFundProfile(payload) {
    try {
        const objResp = await apiCall.post(`transactional/v1/mutualfund/profile/create`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in CreateUserMutualFundProfileList API ->", error.message);
        throw error;
    }
}

export async function getUserMutualFundProfileList() {
    try {
        const objResp = await apiCall.get(`transactional/v1/mutualfund/profile/list`);
        return objResp;
    } catch (error) {
        console.error("Error in getUserMutualfundProfileList API ->", error.message);
        throw error;
    }
}

export async function deleteUserMutualFundProfile(profileId) {

    try {
        const objResp = await apiCall.delete(`transactional/v1/mutualfund/profile/delete?ProfileId=${profileId}`);
        return objResp;
    } catch (error) {
        console.error("Error in DeleteUserMutualFundProfileList API ->", error.message);
        throw error;
    }
}

export async function getUserMutualFundProfileDetails(profileId) {
    try {
        const objResp = await apiCall.get(`transactional/v1/mutualfund/profile/details?ProfileId=${profileId}`);
        return objResp;
    } catch (error) {
        console.error("Error in getUserMutualFundProfileDetails API ->", error.message);
        throw error;
    }
}

export async function mutualFundSearch(payload) {
    try {
        const objResp = await apiCall.get(`transactional/v1/mutualfund/master/scheme?amcCode=&schemeType=&schemeCode=&optCode=&lstUpdtTime=&schemeName=${payload.schemeName}&txtSchemeCode=&pageNo=${payload.pageNo}&pageSize=${payload.pageSize}`);
        return objResp;
    } catch (error) {
        console.error("Error in mutualFundSearch API ->", error.message);
        throw error;
    }
}

export async function getUserAllmutualFundOrders(payload) {
    try {
        const objResp = await apiCall.get(`transactional/v1/mutualfund/order?OBType=${payload.OBType}&productCode=${payload.productCode}&exchangeCode=${payload.exchangeCode}&amcCode=${payload.amcCode}&transactionType=${payload.transactionType}&orderStatus=${payload.orderStatus}&subOrderStatus=${payload.subOrderStatus}&pageNo=${payload.pageNo}&noOfRecordPerPage=${payload.noOfRecordPerPage}&fromDate=${payload.fromDate}&toDate=${payload.toDate}`);
        return objResp;
    } catch (error) {
        console.error("Error in getUserAllmutualFundOrder API ->", error.message);
        throw error;
    }
}

// Vinit R : 26-09-2023 :  Breeze - Mutual Funds - Start
export async function getMutualFundSIPOrdersAPI(payload) {
    try {
        const objResp = await apiCall.get(`transactional/v1/mutualfund/order/systematic?productCode=${payload.productCode}&exchangeCode=${payload.exchangeCode}&amcCode=${payload.amcCode}&transactionType=${payload.transactionType}&subTransactionType=${payload.subTransactionType}&orderStatus=${payload.orderStatus}&subOrderStatus=${payload.subOrderStatus}&orderBookType=${payload.orderBookType}&pageNo=${payload.pageNo}&noOfRecordPerPage=${payload.noOfRecordPerPage}`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in getMutualFundSIPOrdersAPI API ->", error.message);
        throw error;
    }
}

export async function placeUsermutualFundOrder(payload) {
    try {
        const objResp = await apiCall.post(`transactional/v1/mutualfund/order`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in placeUsermutualFundOrder API ->", error.message);
        throw error;
    }
}

export async function placeUsermutualFundSIPOrder(payload) {
    try {
        const objResp = await apiCall.post(`transactional/v1/mutualfund/order/sip`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in placeUsermutualFundSIPOrder API ->", error.message);
        throw error;
    }
}

export async function placeUsermutualFundSTPOrder(payload) {
    try {
        const objResp = await apiCall.post(`transactional/v1/mutualfund/order/stp`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in placeUsermutualFundSTPOrder API ->", error.message);
        throw error;
    }
}

export async function placeUsermutualFundSWPOrder(payload) {
    try {
        const objResp = await apiCall.post(`transactional/v1/mutualfund/order/swp`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in placeUsermutualFundSWPOrder API ->", error.message);
        throw error;
    }
}

export async function placeUsermutualFundSwitchOrder(payload) {
    try {
        const objResp = await apiCall.post(`transactional/v1/mutualfund/order/switch`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in placeUsermutualFundSwitchOrder API ->", error.message);
        throw error;
    }
}

export async function cancelMutualFundOrderAPI(payload) {
    try {
        const objResp = await apiCall.post(`transactional/v1/mutualfund/order/cancel/${payload.orderType}`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in cancelUsermutualFundOrder API ->", error.message);
        throw error;
    }
}

export async function getMutualFundsHoldingAPI(payload) {
    try {
        const objResp = await apiCall.get(`transactional/v1/mutualfund/scheme/holding?AMCCode=&SchemeType=`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in getMutualFundsHoldingAPI API ->", error.message);
        throw error;
    }
}

export async function getMutualFundSummary(payload) {
    try {
        const objResp = await apiCall.get(`transactional/v1/mutualfund/portfolio/summary`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in getMutualFundSummary API ->", error.message);
        throw error;
    }
}

export async function mandateReport(payload) { // Hari K:16-11-2023:BT-119138:funds view: changed API function name
    try {
        const objResp = await apiCall.get(`transactional/v1/mutualfund/master/mandate?MandateStatus=0&MandateType=0&MandateId=`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in mandateReport API ->", error.message);
        throw error;
    }
}


export async function registerMandateAPI(payload) {
    try {
        const objResp = await apiCall.post(`transactional/v1/mutualfund/mandate/registers`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in registerMandate API ->", error.message);
        throw error;
    }
}
// Vinit R : 26-09-2023 :  Breeze - Mutual Funds - End

export async function getNfoWatchList(payload) {
    try {
        const objResp = await apiCall.get(`transactional/v1/mutualfund/nfo/watchlist`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in getNfoWatchList API ->", error.message);
        throw error;
    }
}

export async function getSpreadOrderInfo(payload) {
    try {
        const objResp = await apiCall.post(`transactional/${config.TenantId}/v1/getScripFromSpreadSymbol`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in placeUsermutualFundOrder API ->", error.message);
        throw error;
    }
}


export async function placeMultiScriptOrderCart(payload) {
    try {
        const objResp = await apiCall.post(`transactional/v1/ordercart/placecartorders`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in placeOrderCart API ->", error.message);
        throw error;
    }
}
//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : Start
export async function getOrderCartById(payload) {
    try {
        const objResp = await apiCall.get(`transactional/v1/ordercart/${payload.orderCartId}`);
        return objResp;
    } catch (error) {
        console.error("Error in getOrderCartById API ->", error.message);
        throw error;
    }
}
//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End
export async function orderCartMultiScript(payload) {
    try {
        const objResp = await apiCall.post(`transactional/v1/ordercart`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in placeOrderCart API ->", error.message);
        throw error;
    }
}

// HariK: BT-99161 funds API start

export async function fundsWithdrawal(payload) {
    try {
        const objResp = await apiCall.post(`transactional/v1/fundsWithdrawal`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in fundsWithdrawal API ->", error.message);
        throw error;
    }
}

export async function fundsTransfer(payload) {
    try {
        const objResp = await apiCall.post(`transactional/v1/fundsTransfer`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in fundsTransfer API ->", error.message);
        throw error;
    }
}

export async function fundTransferMappedProduct(payload) {
    try {
        const objResp = await apiCall.get(`transactional/v1/fundTransferMappedProduct/${payload}`);
        return objResp;
    } catch (error) {
        console.error("Error in fundTransferMappedProduct API ->", error.message);
        throw error;
    }
}


export async function producteWiseBalance() {
    try {
        const objResp = await apiCall.get(`transactional/v1/producteWiseBalance`);
        return objResp;
    } catch (error) {
        console.error("Error in producteWiseBalance API ->", error.message);
        throw error;
    }
}


export async function peridiocityWiseBalance() {
    try {
        const objResp = await apiCall.get(`transactional/v1/peridiocityWiseBalance`); // Hari K:08-11-2023 :BT-119138:Funds View - url changed as per updated url
        return objResp;
    } catch (error) {
        console.error("Error in peridiocityWiseBalance API ->", error.message);
        throw error;
    }
}


export async function peridiocityWiseBalanceAndType(objPayload) {
    try {
        const objResp = await apiCall.get(`transactional/v1/peridiocityWiseBalance?periodicity=${objPayload.peridiocity}&type=${objPayload.type}`);
        return objResp;
    } catch (error) {
        console.error("Error in peridiocityWiseBalanceAndType API ->", error.message);
        throw error;
    }
}


export async function marginInfoTokenWise() {
    try {
        const objResp = await apiCall.get(`transactional/v1/marginInfo/:type`);
        return objResp;
    } catch (error) {
        console.error("Error in peridiocityWiseBalanceAndType API ->", error.message);
        throw error;
    }
}




export async function getUserMultiScripOrders(objPayload) {
    try {
        const objResp = await apiCall.get(`/transactional/v1/multilegOrders?offset=${objPayload.offSet}&limit=${objPayload.limit}&orderType=${objPayload.orderType}&orderStatus=${objPayload.orderStatus}`);
        return objResp;
    } catch (error) {
        console.error("Error in getUserMultiScripOrders API ->", error.message);
        throw error;
    }
}

//Mahesh S : 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings- Start

export async function getUserGtdOrders(objPayload, optionalGTTOrGTD) {
    try {
        const objResp = await apiCall.get(`/transactional/v1/${optionalGTTOrGTD}Orders?offset=${objPayload.offSet}&limit=${objPayload.limit}&orderStatus=${objPayload.orderStatus}`);
        return objResp;
    } catch (error) {
        console.error("Error in getUserGtdOrders API ->", error.message);
    }
}
//Mahesh S : 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings- End

//Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start

export async function gtdOrdersHistory(objPayload) {
    try {
        const objResp = await apiCall.get(`/transactional/v1/gtdOrdersHistory?offset=${objPayload.offSet}&limit=${objPayload.limit}&gtdOrderId=${objPayload.gtdOrderId}`);
        return objResp;
    } catch (error) {
        console.error("Error in gtdOrdersHistory API ->", error.message);
    }
}
//Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End

/*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - Start*/

export async function positionConversion(payload) {
    try {
        const objResp = await apiCall.put(`transactional/v1/portfolio/positions`, payload, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error("Error in Position Conversion API ->", error.message);
        throw error;
    }
}

export async function squareOffAllOrders(payload) {
    //Azeem K : Dont pass {isAllowedDeviceInfo: true} in body parameter because it is already there in payload
    try {
        const objResp = await apiCall.post(`transactional/v1/orders/bulkOrders`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in Square Off Orders API ->", error.message);
        throw error;
    }
}

/*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - End*/

/*Mahesh S  : 11-08-2023 : BT-107431 -  Breeze - Watchlist Side Tray - Orders, Positions & Holdings - Start*/

export async function cancelSingleOrders(payload) {
    try {
        if (payload?.validity && (payload?.validity_days || payload?.validity_days === 0)) {
            var objResp = await apiCall.delete(`/transactional/v1/orders/regular/${payload.exchange}/${payload.orderNo}?validity=${payload.validity}&validity_days=${payload.validity_days}`);
        } else {
            objResp = await apiCall.delete(`/transactional/v1/orders/regular/${payload.exchange}/${payload.orderNo}`);
        }
        return objResp;
    } catch (error) {
        console.error("Error in cancel single scrip orders API ->", error.message);
        throw error;
    }
}
export async function cancelAllOrders(payload) {

    try {

        const objResp = apiCall.post(`/transactional/v1/cancelorders`, payload, { isAllowedDeviceInfo: true });

        //Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
        return objResp;
    } catch (error) {
        console.error("Error in cancel single scrip orders API ->", error.message);
        throw error;
    }
}

export async function cancelAllMultilegOrders(payload) {

    try {
        const objResp = apiCall.post(`/transactional/v1/cancelAllMultilegorders`, payload, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error("Error in cancel multileg orders API ->", error.message);
        throw error;
    }
}


// Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
export async function cancelAllSipOrders(payload) {

    try {
        let objLoginSession = getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
        if (objLoginSession) {
            objLoginSession = JSON.parse(objLoginSession);
        } else { }
        const objResp = await apiCall.put(`/transactional/v1/orders/cancelAllEqsipOrder/?product_source=${API_SOURCE.BREEZE}`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in cancel sip scrip orders API ->", error.message);
        throw error;
    }
}
// Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End



export async function modifysingleScripOrder(objPayload, exchange, orderNo) {
    try {
        const objResp = await apiCall.put(`/transactional/v1/orders/regular/${exchange}/${orderNo}`, objPayload, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error('error in modifysingleScripOrder API ->', error.message);
        throw error;
    }
}

// Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders Start
export async function modifySpreadOrder(objPayload, orderNo) {
    try {
        const objResp = await apiCall.put(`/transactional/v1/orders/multileg/modify/${orderNo}`, objPayload, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error('error in modifysingleScripOrder API ->', error.message);
        throw error;
    }
}
// Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders End

// Deepti B : 04-04-2024 : Order Cart - removed unnecessary payload
export async function orderCart() {
    try {
        const objResp = await apiCall.get(`/transactional/v1/ordercart`);
        return objResp;
    } catch (error) {
        console.error('error in orderCart API ->', error.message);
    }
}

/*Mahesh S  : 11-08-2023 : BT-107431 -  Breeze - Watchlist Side Tray - Orders, Positions & Holdings - End*/

// Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - Start
export async function dpDetailsEDIS() {
    try {
        const objResp = await apiCall.get("/transactional/v1/getDPDetailsEDIS/", { lock: true });
        return objResp;
    } catch (error) {
        console.error("error in getting DP details for EDIS", error.message);
        throw error;
    }
}

export async function interopConfiguration() {
    try {
        const objResp = await apiCall.get("/transactional/v1/getInteropConfiguration", { lock: true });
        return objResp;
    } catch (error) {
        console.error("error in getting interop configuration details", error.message);
        throw error;
    }
}

export async function edisSummaryDetails(payload) {
    const { mktSegmentId, token, productTypeForApi } = payload;
    let params = "";
    if (productTypeForApi !== "") {
        params = "mktSegID=" + mktSegmentId + "&token=" + token + "&productType=" + productTypeForApi;
    }
    else {
        params = "mktSegID=" + mktSegmentId + "&token=" + token;
    }
    try {
        const objResponse = await apiCall.get(`transactional/v1/edis/summary?${params}`);
        return objResponse;
    } catch (error) {
        console.error("error in getting EDIS summary details", error.message);
        throw error;
    }
}
// Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - End


// Hari K:06-11-2023 :BT-119138:Funds View - start
export async function mktAllowed(product) {   // to get markets allowed to user
    try {
        const objResp = await apiCall.get(`/transactional/v1/producteWiseBalance/?mktAllowed=${product}`);
        return objResp;
    } catch (error) {
        console.error('error in mktAllowed API ->', error.message);
    }
}


export async function bankList() {   // to get markets allowed to user
    try {
        const objResp = await apiCall.get(`/transactional/v2/getBankAccList`);
        return objResp;
    } catch (error) {
        console.error('error in getBankAccList API ->', error.message);
    }
}

export async function availableBankList() {   // to get markets allowed to user
    try {
        const objResp = await apiCall.get(`/transactional/v1/banklist`);
        return objResp;
    } catch (error) {
        console.error('error in banklist API ->', error.message);
    }
}



export async function mappedBanksList(objPayload) {   // to get markets allowed to user
    try {
        const objResp = await apiCall.get(`/transactional/v1/getMappedBanksList/${objPayload?.product}/${objPayload?.bank}`);
        return objResp;
    } catch (error) {
        console.error('error in getMappedBanksList API ->', error.message);
    }
}


// Hari K:06-11-2023 :BT-119138:Funds View - end

// BT-106965_27_02_2024_SrikanthRao_ordercart_start


export async function getOrderCartApi() {   // to get markets allowed to user
    try {
        const objResp = await apiCall.get(`/transactional/v1/ordercart`);
        return objResp;
    } catch (error) {
        console.error('error in getOrderCartApi API ->', error.message);
    }
}


export async function updateOrdercartApi(payload) {
    try {
        const objResp = await apiCall.put(`/transactional/v1/ordercart`, payload);
        return objResp;
    } catch (error) {
        console.error('error in updateOrdercartApi API ->', error.message);
    }
}
export async function deleteOrdercartApi(payload) {
    try {
        const objResp = await apiCall.delete(`/transactional/v1/ordercart/${payload}`,);
        return objResp;
    } catch (error) {
        console.error('error in deleteOrdercartApi API ->', error.message);
    }
}
// BT-106965_27_02_2024-SrikanthRao_ordercart_end

//BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start
export async function createOrderCart(payload) {
    try {
        const objResp = await apiCall.post(`/transactional/v1/ordercart/placecartorders`, payload);
        return objResp;
    } catch (error) {
        console.error('error in updateOrdercartApi API ->', error.message);
    }
}
export async function saveCartData(payload) {
    try {
        const objResp = await apiCall.post(`/transactional/v1/ordercart`, payload);
        return objResp;
    } catch (error) {
        console.error('error in saveCartData API ->', error.message);
    }
}
//BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - End


// Hari k:19-06-2024; withdrawal cancelation-start



export async function fundsWithdrawalCancellation(payload) {
    try {
        const objResp = await apiCall.post(`/transactional/v1/fundsWithdrawalCancellation`, payload);
        return objResp;
    } catch (error) {
        console.error('error in updateOrdercartApi API ->', error.message);
    }
}

export async function eqSipScripMaster() {
    try {
        const objResp = await apiCall.get(`/transactional/v1/eqsipScripMaster`);

        return objResp;
    } catch (error) {
        console.error('error in getEqSipScripMaster API ->', error.message);
        throw error;
    }
}
//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start

export async function exitCoverOrder(exchange, orderid, price, orderType) {
    try {
        const objResp = await apiCall.delete(`/transactional/v1/orders/${orderType}/${exchange}/${orderid}?${orderType === 'cover' ? 'ltp' : 'price'}=${price}`,);
        return objResp;
    } catch (error) {
        console.error('error in exitCoverOrder API ->', error.message);
        throw error;
    }
}
//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End